export interface QAItem {
  question: string;
  answer: string;
}

export const employerQA: QAItem[] = [
  {
    question: 'What solution does BoostHiring provide for recruitment?',
    answer:
      'BoostHiring makes working with recruiters simple and cost-efficient. Post a role once, activate multiple agencies, track submissions and interviews in one platform, and pay only after a successful hire and based on your posted service fees for hiring via agency.',
  },
  {
    question: 'Is BoostHiring a recruitment agency?',
    answer:
      'No. BoostHiring is a marketplace platform that connects employers with vetted recruitment agencies. We are independent and do not promote preferred vendors — all registered recruiters compete equally for your job orders.',
  },
  {
    question: 'What are the fees for employers?',
    answer:
      'Using BoostHiring is free for employers. You only pay the service fee you define in your job posting to the recruiter who successfully places the candidate.',
  },
  {
    question: 'Do recruiters provide a guarantee on placements?',
    answer:
      'Yes. All recruiters on BoostHiring must provide at least minimum 90-day replacement guarantee for permanent placements.',
  },
  {
    question: 'Can I hire contract or temporary workers?',
    answer:
      'Yes. BoostHiring supports both permanent hires and contract placements, depending on your hiring needs.',
  },
  {
    question: 'Does BoostHiring store resumes or share information?',
    answer:
      'No. Candidate resumes are not permanently stored and are removed after the hiring process ends. BoostHiring does not share your data with third parties.',
  },
  {
    question: 'Can I work directly with recruiters outside the platform?',
    answer:
      'No. All collaboration must remain within BoostHiring to ensure transparency and enforce the service fee terms defined in your job order.',
  },
  {
    question: 'What if multiple recruiters submit the same candidate?',
    answer:
      'Candidate ownership is determined by the first verified submission timestamp. Employers may also reject candidates already introduced directly or by another agency within the previous 12 months.',
  },
  {
    question: 'Do employers pay to use BoostHiring?',
    answer:
      'No. Posting jobs is free. You only pay the recruiter service fee you define if a hire is made.',
  },
  {
    question: 'Who are the recruiters on BoostHiring?',
    answer:
      'All agencies are verified before joining the platform to ensure employers work with registered and vetted recruiters.',
  },
];

export const agencyQA: QAItem[] = [
  {
    question: 'What does BoostHiring offer recruitment agencies?',
    answer:
      'BoostHiring gives agencies direct access to verified job orders from companies actively working with external recruiters. Focus on placing candidates instead of searching for clients.',
  },
  {
    question: 'Is BoostHiring a recruitment agency?',
    answer:
      'No. BoostHiring is an independent marketplace that connects employers with vetted recruitment agencies. All agencies compete equally for open job orders posted by employers.',
  },
  {
    question: 'Why does account approval take up to 48 hours after SignUp?',
    answer:
      'We verify every recruiter before granting access to maintain platform quality. This ensures employers work only with registered and vetted local agencies based in USA or Canada.',
  },
  {
    question: 'Are there limits on candidate submissions?',
    answer:
      'Yes. The Base plan allows up to 5 active job orders and 5 candidate submissions per role. Higher limits are available through Plus and Pro plans.',
  },
  {
    question: 'How do recruiters get paid?',
    answer:
      "When your candidate is hired, you invoice the employer directly through the platform. Payment is made within 30 days of the candidate's start date, based on the service fee defined in the job order.",
  },
];
